import { useContext } from "react";

import { OutputDocumentsPanelContext } from "./OutputDocumentsPanelContext";

export function useOutputDocumentsPanel() {
  const context = useContext(OutputDocumentsPanelContext);
  if (!context) {
    throw new Error("useOutputDocumentsPanel must be used within a OutputDocumentsPanelProvider");
  }
  return context;
}
